// extracted by mini-css-extract-plugin
export var column = "_tq-0";
export var divider = "_tq-2";
export var timePicker = "_tq-1";